"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionInfoToJSON = exports.SessionInfoFromJSONTyped = exports.SessionInfoFromJSON = void 0;
var runtime_1 = require("../runtime");
function SessionInfoFromJSON(json) {
    return SessionInfoFromJSONTyped(json, false);
}
exports.SessionInfoFromJSON = SessionInfoFromJSON;
function SessionInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gameId': !(0, runtime_1.exists)(json, 'gameId') ? undefined : json['gameId'],
        'gameTitle': !(0, runtime_1.exists)(json, 'gameTitle') ? undefined : json['gameTitle'],
        'gameThumbnail': !(0, runtime_1.exists)(json, 'gameThumbnail') ? undefined : json['gameThumbnail'],
        'lastPlayed': !(0, runtime_1.exists)(json, 'lastPlayed') ? undefined : (new Date(json['lastPlayed'])),
        'sessionDuration': !(0, runtime_1.exists)(json, 'sessionDuration') ? undefined : json['sessionDuration'],
        'xpEarned': !(0, runtime_1.exists)(json, 'xpEarned') ? undefined : json['xpEarned'],
        'fuelEarned': !(0, runtime_1.exists)(json, 'fuelEarned') ? undefined : json['fuelEarned'],
    };
}
exports.SessionInfoFromJSONTyped = SessionInfoFromJSONTyped;
function SessionInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gameId': value.gameId,
        'gameTitle': value.gameTitle,
        'gameThumbnail': value.gameThumbnail,
        'lastPlayed': value.lastPlayed === undefined ? undefined : (value.lastPlayed.toISOString()),
        'sessionDuration': value.sessionDuration,
        'xpEarned': value.xpEarned,
        'fuelEarned': value.fuelEarned,
    };
}
exports.SessionInfoToJSON = SessionInfoToJSON;
